export interface ListPage {
  layout: string;
}
export interface UsersState {
  listPage: ListPage
}

export function createInitialUsersState(): UsersState {
  return {
    listPage: {
      layout: "list"
    }
  }
}